import { Routes } from '@angular/router';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    // Login en la URL raíz: https://...azurestaticapps.net/
    path: '',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
    pathMatch: 'full',
  },
  {
    // Compatibilidad: /login redirige a la raíz (evita 404 y URLs duplicadas)
    path: 'login',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [roleGuard],
  },
  {
    path: 'cargos',
    loadComponent: () =>
      import('./features/cargo/cargo-list.component').then((m) => m.CargoListComponent),
    canActivate: [roleGuard],
  },
  {
    path: 'departamentos',
    loadComponent: () =>
      import('./features/departamento/departamento-list.component').then(
        (m) => m.DepartamentoListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'diagnosticos',
    loadComponent: () =>
      import('./features/diagnostico/diagnostico-list.component').then(
        (m) => m.DiagnosticoListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'tipos-institucion',
    loadComponent: () =>
      import('./features/tipo-institucion/tipo-institucion-list.component').then(
        (m) => m.TipoInstitucionListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'opciones-na-institucion',
    loadComponent: () =>
      import('./features/opcion-na-institucion/opcion-na-institucion-list.component').then(
        (m) => m.OpcionNaInstitucionListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'resultados-rnd-ins',
    loadComponent: () =>
      import('./features/resultado-rnd-ins/resultado-rnd-ins-list.component').then(
        (m) => m.ResultadoRndInsListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'instituciones-organo',
    loadComponent: () =>
      import('./features/institucion-organo/institucion-organo-list.component').then(
        (m) => m.InstitucionOrganoListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'modos-legalizacion',
    loadComponent: () =>
      import('./features/modo-legalizacion/modo-legalizacion-list.component').then(
        (m) => m.ModoLegalizacionListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'motivos-descarte',
    loadComponent: () =>
      import('./features/motivo-descarte/motivo-descarte-list.component').then(
        (m) => m.MotivoDescarteListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'municipios',
    loadComponent: () =>
      import('./features/municipio/municipio-list.component').then((m) => m.MunicipioListComponent),
    canActivate: [roleGuard],
  },
  {
    path: 'sexos',
    loadComponent: () =>
      import('./features/sexo/sexo-list.component').then((m) => m.SexoListComponent),
    canActivate: [roleGuard],
  },
  {
    path: 'ips-generadoras',
    loadComponent: () =>
      import('./features/ips-generadora/ips-generadora-list.component').then(
        (m) => m.IpsGeneradoraListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'profesionales',
    loadComponent: () =>
      import('./features/profesional/profesional-list.component').then(
        (m) => m.ProfesionalListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'instituciones',
    loadComponent: () =>
      import('./features/institucion/institucion-list.component').then(
        (m) => m.InstitucionListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'roles',
    loadComponent: () =>
      import('./features/rol/rol-list.component').then((m) => m.RolListComponent),
    canActivate: [roleGuard],
  },
  {
    path: 'servicios',
    loadComponent: () =>
      import('./features/servicio-catalog/servicio-catalog-list.component').then(
        (m) => m.ServicioCatalogListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'tipos-documento',
    loadComponent: () =>
      import('./features/tipo-documento/tipo-documento-list.component').then(
        (m) => m.TipoDocumentoListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'usuarios',
    loadComponent: () =>
      import('./features/usuario/usuario-list.component').then((m) => m.UsuarioListComponent),
    canActivate: [roleGuard],
  },
  {
    path: 'tipos-salida',
    loadComponent: () =>
      import('./features/tipo-salida/tipo-salida-list.component').then(
        (m) => m.TipoSalidaListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'donor-management',
    loadComponent: () =>
      import('./features/donor-management/donor-management.component').then(
        (m) => m.DonorManagementComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'tipos-oferta',
    loadComponent: () =>
      import('./features/tipo-oferta/tipo-oferta-list.component').then(
        (m) => m.TipoOfertaListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'resultados-entrevista',
    loadComponent: () =>
      import('./features/resultado-entrevista/resultado-entrevista-list.component').then(
        (m) => m.ResultadoEntrevistaListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'contraindicaciones',
    loadComponent: () =>
      import('./features/contraindicacion/contraindicacion-list.component').then(
        (m) => m.ContraindicacionListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'tipos-muerte',
    loadComponent: () =>
      import('./features/tipo-muerte/tipo-muerte-list.component').then(
        (m) => m.TipoMuerteListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'organos',
    loadComponent: () =>
      import('./features/organo/organo-list.component').then((m) => m.OrganoListComponent),
    canActivate: [roleGuard],
  },
  {
    path: 'categorias-organo',
    loadComponent: () =>
      import('./features/categoria-organo/categoria-organo-list.component').then(
        (m) => m.CategoriaOrganoListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: 'organos-caso',
    loadComponent: () =>
      import('./features/organo-caso/organo-caso-list.component').then(
        (m) => m.OrganoCasoListComponent
      ),
    canActivate: [roleGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
